import React from "react";
import PropTypes from "prop-types";
import { Alert, Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { SET_KYC_STEP } from "../../store/user/actionTypes";

const StepIntro = ({ t }) => {
  let dispatch = useDispatch();

  const handleNext = () => {
    dispatch({ type: SET_KYC_STEP, step: "signIn" });
  };

  const handleLinkClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <Alert variant="">
        <p>{t("To use Ensuro's products and services, you must complete the following steps:")}</p>
        <ul>
          <li>{t("Acceptance of Terms & Conditions and other documents")}</li>
          <li>{t("Investor test")}</li>
          <li>
            <Trans>
              Know Your Customer (KYC) screening via{" "}
              <a
                href="https://www.idenfy.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007bff", textDecoration: "underline" }}
                onClick={handleLinkClick}
              >
                Idenfy
              </a>
            </Trans>
          </li>
          <li>{t("Automated risk checks")}</li>
        </ul>
        <p>{t("And you are done!")}</p>
        <p>
          {t(
            "This process is essential for protecting you and our platform from fraudulent and illegal activities. Your personal information will be processed by Idenfy in accordance with their privacy policy."
          )}
        </p>
      </Alert>
      <Modal.Footer>
        <Button variant="primary" onClick={handleNext}>
          {t("Next")}
        </Button>
      </Modal.Footer>
    </>
  );
};

StepIntro.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(StepIntro);
